import React from 'react'

// Components
import { Button } from '@mui/material'

// Types and Styles
import { StyledButtonProps } from './StyledButton.types'
import styles from './StyledButton.module.scss'

const StyledButton: React.FC<StyledButtonProps> = ({
  label,
  onClick,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  disabled = false,
  fullWidth = false,
  startIcon,
  endIcon,
  ...rest
}) => {
  return (
    <Button
      variant={variant}
      color={color}
      size={size}
      disabled={disabled}
      fullWidth={fullWidth}
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      className={styles.styledButton}
      {...rest}
    >
      {label}
    </Button>
  )
}

export default StyledButton
